import { Button } from '@hakimo-ui/shared/ui-base';
import {
  MagnifyingGlassMinusIcon,
  MagnifyingGlassPlusIcon,
} from '@heroicons/react/24/outline';
import clsx from 'clsx';
import { ArrowPointerIcon, PanHandIcon, ResetIcon } from '../icons';

interface Props {
  isZoomed: boolean;
  isPanning: boolean;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onReset: () => void;
  onPointer: () => void;
  onPan: () => void;
  topOffset?: string;
}

export function ZoomControls(props: Props) {
  const {
    isZoomed,
    isPanning,
    onZoomIn,
    onZoomOut,
    onReset,
    onPointer,
    onPan,
    topOffset = '0',
  } = props;

  return (
    <div
      className={clsx(
        'group/zoom absolute right-0 z-10 flex items-center gap-1 rounded-bl-md bg-black/40 p-1 backdrop-blur-sm transition-opacity',
        !isZoomed && 'opacity-0 group-hover/zoomable:opacity-100'
      )}
      style={{ top: topOffset }}
    >
      <Button
        variant="icon"
        onClick={onPointer}
        title="Pointer"
        className={clsx(
          'h-7 w-7 focus:ring-offset-0',
          !isPanning
            ? 'bg-primary-600/60 hover:!bg-primary-700/80'
            : 'hover:bg-white/20'
        )}
      >
        <ArrowPointerIcon className="h-5 w-5 fill-white stroke-white" />
      </Button>
      <Button
        variant="icon"
        onClick={onPan}
        title="Pan"
        disabled={!isZoomed}
        className={clsx(
          'h-7 w-7 focus:ring-offset-0',
          isPanning
            ? 'bg-primary-600/60 hover:!bg-primary-700/80'
            : 'hover:bg-white/20',
          !isZoomed && 'opacity-50'
        )}
      >
        <PanHandIcon className="h-5 w-5 fill-white" />
      </Button>
      <Button
        variant="icon"
        onClick={onReset}
        title="Reset"
        disabled={!isZoomed}
        className={clsx(
          'h-7 w-7 hover:!bg-white/20 focus:ring-offset-0',
          !isZoomed && 'opacity-50'
        )}
      >
        <ResetIcon className="h-5 w-5 fill-white" />
      </Button>
      <div className="mx-0.5 h-4 w-px bg-white/30" />
      <Button
        variant="icon"
        onClick={onZoomIn}
        title="Zoom In"
        className="h-7 w-7 hover:!bg-white/20 focus:ring-offset-0"
      >
        <MagnifyingGlassPlusIcon className="h-5 w-5 stroke-white" />
      </Button>
      <Button
        variant="icon"
        onClick={onZoomOut}
        title="Zoom Out"
        disabled={!isZoomed}
        className={clsx(
          'h-7 w-7 hover:!bg-white/20 focus:ring-offset-0',
          !isZoomed && 'opacity-50'
        )}
      >
        <MagnifyingGlassMinusIcon className="h-5 w-5 stroke-white" />
      </Button>
    </div>
  );
}

export default ZoomControls;
